var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18m3.531-9.469a.75.75 0 0 0-1.06-1.06l-3.468 3.47-1.469-1.47a.75.75 0 0 0-1.06 1.06l2.001 2a.747.747 0 0 0 1.06 0z"
  })));
};
export default SvgCheckCircle;